import React from "react";
import NumberFormat from "react-number-format";

export class KreisPreview extends React.Component {
    constructor(props) {
        super(props);
    }

    handleCloseClick() {
        this.props.closePopup();
    }

    render() {
        if (!this.props.kreis) {
            return null;
        }
        return (
            <div style={this.props.showCloseIcon ? {paddingTop: "10px"} : {}}>
                {this.props.showCloseIcon && this.props.arrowX &&
                (this.props.arrowPos === "bottom"
                        ? <div className={"arrowPopup"} style={{right: this.props.arrowX.toString() + 'px', top: '100%'}}></div>
                        : <div className={"arrowPopup top"} style={{right: this.props.arrowX.toString() + 'px'}}></div>
                )
                }
                {this.props.showCloseIcon &&
                    <div onClick={this.handleCloseClick.bind(this)} className="popupClose mouse-pointer">
                        <b>×</b>
                    </div>
                }
                <div className="popoverInner text-center">
                    <h3><b>{this.props.kreis.city}</b></h3>
                    <div>
                        <NumberFormat
                            value={this.props.kreis.population}
                            decimalScale={0}
                            fixedDecimalScale={true}
                            displayType={'text'}
                            thousandSeparator={'.'}
                            decimalSeparator={','}
                        /> Einwohner
                    </div>
                    <hr />
                    <div style={{marginBottom: "18px", marginTop: "5px"}}>Neue Fälle in den letzten 7 Tagen:</div>
                    <b>Je 100.000 Einwohner</b>
                    <div className="xxl-number">
                        <NumberFormat
                            value={this.props.kreis[this.props.selected_date].inzidenz}
                            decimalScale={1}
                            fixedDecimalScale={true}
                            displayType={'text'}
                            thousandSeparator={'.'}
                            decimalSeparator={','}
                        />
                    </div>
                    <div className="text-red" style={{marginTop: "10px"}}><b>Insgesamt</b></div>
                    <div className="xl-number text-red">
                        <NumberFormat
                            value={this.props.kreis[this.props.selected_date].last_7}
                            decimalScale={0}
                            fixedDecimalScale={true}
                            displayType={'text'}
                            thousandSeparator={'.'}
                            decimalSeparator={','}
                        />
                    </div>
                    <p className="text-right" style={{marginTop: "4px"}}>
                        <small>
                            <i>Stand:&nbsp;
                                {new Date(this.props.selected_date).toLocaleDateString("de-de", {year: "numeric", month: "short", day: "numeric"})}
                            </i>
                        </small>
                    </p>
                </div>
            </div>
        )
    }
}